<template>
    <div class="moreInfoModal" :class="{ 'moreInfoModal--active': active }">
        <div class="moreInfoModal__overlay" @click="moreInfoItemClose"></div>
        <div class="moreInfoModal__content">
            <div class="moreInfoModal__container">
                <div class="moreInfoModal__wrapper">
                    <div class="moreInfoModal_head">
                        <div class="moreInfoModal_head_title">
                            {{ item?.name }}
                        </div>
                        <button
                            class="moreInfoModal_head_btn"
                            @click="moreInfoItemClose"
                            :title="`${$t('message.tvChannel.close')}`"
                            :aria-label="`${$t('message.tvChannel.close')}`"
                        >
                            <IClose />
                        </button>
                    </div>
                    <div class="moreInfoModal_body">
                        <div class="moreInfoModal_body_time">
                            {{ fullTime(item?.begin_time) }} -
                            {{ fullTime(item?.end_time) }}
                        </div>
                        <div class="moreInfoModal_body_text">
                            {{
                                item?.description
                                    ? item?.description
                                    : "Описание телепрограммы отсутствует"
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { converter } from "../../converter.js";
import IClose from "./icons/IClose.vue";

export default {
    props: ["data", "active"],
    components: { IClose },
    data() {
        return {
            item: {},
        };
    },
    watch: {
        data(value) {
            this.item.name = value.program_name
                ? value.program_name
                : value.name;
            this.item.begin_time = value.begin_time || value.program_begin_time;
            this.item.end_time = value.end_time || value.program_end_time;
            this.item.description =
                value?.description?.length > 2 ||
                value?.program_description?.length > 2
                    ? value.description || value.program_description
                    : "";
        },
    },
    methods: {
        fullTime(s) {
            return converter(s)[0];
        },
        moreInfoItemClose() {
            this.$emit("moreInfoItemActive", null);
        },
    },
};
</script>
